export interface LanguageOption {
  code: string;
  name: string;
}

/** Short code shown beside the language dropdown, e.g. "EN" from "en-EN". */
export function getEuropeanLanguageShortCode(code: string): string {
  if (!code.trim()) {
    return '';
  }
  return code.split('-')[0]?.toUpperCase() ?? code.toUpperCase();
}

/** Text inside the language dropdown (language name only; short code is shown in the badge). */
export function formatEuropeanLanguageOptionLabel(option: LanguageOption): string {
  return option.name;
}

export const EUROPEAN_LANGUAGES: LanguageOption[] = [
  { code: 'en-EN', name: 'English' },
  { code: 'es-ES', name: 'Spanish' },
  { code: 'tr-TR', name: 'Turkish' },
  { code: 'de-DE', name: 'German' },
  { code: 'fr-FR', name: 'French' },
  { code: 'it-IT', name: 'Italian' },
  { code: 'pt-PT', name: 'Portuguese' },
  { code: 'ru-RU', name: 'Russian' },
  { code: 'pl-PL', name: 'Polish' },
  { code: 'nl-NL', name: 'Dutch' },
  { code: 'el-GR', name: 'Greek' },
  { code: 'cs-CZ', name: 'Czech' },
  { code: 'ro-RO', name: 'Romanian' },
  { code: 'hu-HU', name: 'Hungarian' },
  { code: 'sv-SE', name: 'Swedish' },
  { code: 'fi-FI', name: 'Finnish' },
  { code: 'da-DK', name: 'Danish' },
  { code: 'no-NO', name: 'Norwegian' },
  { code: 'sk-SK', name: 'Slovak' },
  { code: 'bg-BG', name: 'Bulgarian' },
  { code: 'hr-HR', name: 'Croatian' },
  { code: 'sr-RS', name: 'Serbian' },
  { code: 'sl-SI', name: 'Slovenian' },
  { code: 'et-EE', name: 'Estonian' },
  { code: 'lv-LV', name: 'Latvian' },
  { code: 'lt-LT', name: 'Lithuanian' },
  { code: 'ga-IE', name: 'Irish' },
  { code: 'mt-MT', name: 'Maltese' },
  { code: 'is-IS', name: 'Icelandic' },
  { code: 'mk-MK', name: 'Macedonian' },
  { code: 'sq-AL', name: 'Albanian' },
  { code: 'bs-BA', name: 'Bosnian' },
  { code: 'uk-UA', name: 'Ukrainian' },
  { code: 'be-BY', name: 'Belarusian' },
  { code: 'ca-ES', name: 'Catalan' },
  { code: 'eu-ES', name: 'Basque' },
  { code: 'cy-GB', name: 'Welsh' }
];

